import { Button } from '@mui/material'
import React from 'react'
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Btn = ({ bg, color, text, path, onClick, type = 'button', width = 'fit-content', sx, className = '' }) => {
    const { i18n } = useTranslation();
    const btnText = text || (i18n.language === 'en' ? 'Discover More' : 'اسكتشف المزيد');

    const navigate = useNavigate()
    const theme = useTheme();
    return (
        <>
            <Button
                type={type}
                onClick={onClick ? onClick : () => navigate(path)}
                size="large"
                sx={{
                    background: bg ? bg : theme.palette.primary.main,
                    color: color ? color : theme.palette.primary.text, textTransform: 'capitalize', px: 4, py: 1, ":hover": {
                        background: theme.palette.primary.text,
                        color: theme.palette.primary.main,
                    },
                    borderRadius: '8px',
                    width: width,
                    fontWeight: 'bold',
                    mt: 1,
                    ...sx
                }} className={className}>
                {btnText}
            </Button>
        </>
    )
}

export default Btn